import developmentHosts from './development';

const hosts = {
  ...developmentHosts,
  CTL_ELASTIC_SEARCH: '',
} as const;

export default hosts;
